import { BiSolidRightArrow } from 'react-icons/bi';
import { Box, useTheme } from '@mui/material';

export default function SubtitleAdornmentLeftIcon(props) {
  const theme = useTheme();

  return (
    <Box {...props}>
      <BiSolidRightArrow
        color={theme.palette.primary.main}
        size={12}
        style={{ display: 'block' }}
      />
    </Box>
  );
}
